module.exports = "\ndiv.palette {\n  float:left;\n  width: auto;\n  margin: 12px 24px;\n}\n\n.palette li {\n  list-style: none;\n}\n\n.color-box {\n  display: inline-block;\n  margin: 0 4px;\n  vertical-align: center;\n  width: 24px;\n  height: 24px;\n  border: 1px solid;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-box-shadow: 0 1px 2px #FFF;\n          box-shadow: 0 1px 2px #FFF;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/opzioni/opzioni.css
// module id = ./src/app/opzioni/opzioni.css
// module chunks = main